import styled from 'styled-components';

export const Container = styled.div`
  >div {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }
`;
